// © Microsoft Corporation. All rights reserved.

import { DarkModeBackgroundColor, LightModeBackgroundColor } from "@msnews/experiences-base";
import { DesignSystem, isDarkMode } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../utils/enums";
import { neutralLayerCard } from "@microsoft/fast-components-styles-msft";

export const ProfileCommentsSuperAppStyles = (config: DesignSystem) => ({
    profileCommentsSuperAppContainer: {
        margin: "0",
        padding: "16px",
        "border-radius": "20px 20px 0 0",
        background: isDarkMode(config) ? DarkModeBackgroundColor : LightModeBackgroundColor,

        "& .cwt-profile-comment-item-list": {
            display: "flex",
            "flex-direction": "column",
            "align-items": "center"
        },

        "& .cwt-profile-comment": {
            "max-width": "75vw",
            width: "75vw",
            padding: "16px",
            border: "none",
            "border-radius": "6px",
            "margin-bottom": "16px",
            "box-shadow": applyLocalizedProperty("0px 0px 1px rgba(0, 0, 0, 0.05), 0px 0px 12px rgba(0, 0, 0, 0.08)",  "0px 12.8px 28.8px rgba(0, 0, 0, 0.13), 0px 0px 9.2px rgba(0, 0, 0, 0.11)", config.direction),
            background: neutralLayerCard,

            "& .cwt-header": {
                "& .cwt-title": {
                    "font-size": "15px"
                },

                "& .cwt-posted-at": {
                    color: isDarkMode(config) ? "#ffffff" : "#212121",
                    "font-size": "15px"
                },

                "& .dot-before:before": {
                    opacity: "1",
                    margin: "0 4px"
                },

                "& .cwt-comment-config-container": {
                    "& .cwt-icon": {
                        color: "#919191"
                    },
                    margin: "-5px",
                    padding: "5px"
                }
            },

            "& .cwt-message": {
                color: isDarkMode(config) ? "white" : "#6E6E6E",
                "font-size": "15px",
                "letter-spacing": applyLocalizedProperty("-0.24px", "0", config.direction),

                "& .cwt-show-clamped-btn": {
                    color: isDarkMode(config) ? "#6794D7" : "#3D6CDC"
                }
            },

            "& .cwt-engagements": {
                "& .cwt-replies-link": {
                    color: isDarkMode(config) ? "#6794D7" : "#3D6CDC",
                    "font-size": "12px"
                },

                "& .cwt-reaction-counts": {
                    "& > .cwt-icon": {
                        "font-size": "15px !important",

                        "& .cwt-icon-label": {
                            "font-size": "12px"
                        },
                        "& .cwt-icon-vector": {
                            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "0"
                        }
                    }
                }
            },

            "& .cwt-content-info": {
                padding: "8px",
                border: "1px solid",
                "border-color": isDarkMode(config) ? "rgba(255, 255, 255, 0.08)" : "#DDDDDD",

                "& .cwt-content-image": {
                    width: "64px"
                },

                "& .cwt-content-title": {
                    color: isDarkMode(config) ? "white" : "#212121",
                    "font-weight": "normal",
                    "font-size": "13px"
                }
            }
        },

        ["&." + enums.responsiveLevels.L0]: {
            background: isDarkMode(config) ? "#181818" : "#FFFFFF",
            "& .cwt-profile-comment-item-list": {
                display: "contents"
            },
            "& .cwt-profile-comment": {
                "border-radius": "12px",
                "max-width": "100%",
                width: "auto"
            }
        }
    }
});